import * as types from "./actions";
import APIUtil from "./../config/APIUtil";
import UrlConstants from "./../config/UrlConstants";
import * as code from "./../config/Constants";

/**
 *
 * @desc Get account owners shops
 */

export function getAllShopsAction(data) {
  var url = UrlConstants.shopsUrl + "/all";
  return function(dispatch) {
    return APIUtil.postMethod(url, data, false).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_All_SHOPS,
          shops: response.data.data,
          totalPages: response.data.total,
        });
      } else {
        dispatch({
          type: types.GET_All_SHOPS,
          shops: [],
          totalPages: 0,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Get account owners shop details by ownerId
 */

export function getShopDetailsAction(ownerId) {
  let url = UrlConstants.shopDetailsUrl;
  url = url.replace("{ownerId}", ownerId);

  return function(dispatch) {
    return APIUtil.getMethod(url, false).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc Get shop details from public profile url
 */

export function getShopDetailsByPublicUrlAction(urlParam) {
  let url = UrlConstants.shopsUrl + "/getStudioDetails?publicUrl=" + urlParam;

  return function(dispatch) {
    return APIUtil.getMethod(url, false).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc Get artists details by ownerId
 */

export function getArtistDetailsAction(id, ownerId) {
  let url = UrlConstants.artistDetailsUrl;
  url = url.replace("{artistId}", id);
  url = url.replace("{ownerId}", ownerId);

  return function(dispatch) {
    return APIUtil.getMethod(url, false).then((response) => {
      return response;
    });
  };
}

/**
 *
 * @desc Get shop details from public profile url
 */

export function getArtistDetailsByPublicUrlAction(urlParam) {
  let url =
    UrlConstants.shopsUrl + "/artistsDetailsByURL?publicUrl=" + urlParam;

  return function(dispatch) {
    return APIUtil.getMethod(url, false).then((response) => {
      return response;
    });
  };
}

/**
 * @desc Transaction Type - get All data
 */
export function getTransactionTypeAction() {
  let url = UrlConstants.shopsUrl + "/getPublicTransactionType";

  return function(dispatch) {
    return APIUtil.getMethod(url, false).then((response) => {
      dispatch({
        type: types.TRANSACTION_TYPE,
        transactionType: response.status == code.OK ? response.data : [],
      });
      return response.data || [];
    });
  };
}

/**
 * @desc get timezone list
 */
export function getTimezoneListAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.shopsUrl + "/timezone", false).then(
      (response) => {
        if (response.status == code.OK) {
          dispatch({
            type: types.GET_TIME_ZONE,
            timezoneList: response.data,
          });
        } else {
          dispatch({
            type: types.GET_TIME_ZONE,
            timezoneList: [],
          });
        }

        return response.data || [];
      }
    );
  };
}

/**
 *
 * @desc Api call for get admin quick appointment template
 */
export function adminGetQuickAppointmentTemplateAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.shopsUrl + "/campaign", false).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.ADMIN_GET_MASTER_TEMPLATE_DATA,
            adminMasterTemplates: response.data.data,
            totalAdminTemplates: response.data.total,
          });
        } else {
          dispatch({
            type: types.ADMIN_GET_MASTER_TEMPLATE_DATA,
            adminMasterTemplates: {},
            totalAdminTemplates: 0,
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Get User Roles new
 */

export function getUserRolesActionNew(id) {
  let url = UrlConstants.getRolesPublicUrl;
  url = url.replace("{ownerId}", id);
  return function(dispatch) {
    return APIUtil.getMethod(url, false).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_ROLES,
          roles: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ROLES,
          roles: [],
        });
      }
      return response ? response.data : [];
    });
  };
}

/**
 * add client for quick appointment
 * @desc Add  contact Action New 22-12-2022
 */
export function addQuickClientAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.shopsUrl + "/AddShopQuickClient",
      data,
      false
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage:
            "Thanks for registering with us, Our team will review your application and you will be notified once your account is Approved.",
        });
      } else {
        dispatch({
          type: types.ADD_CONTACT,
          contactResponse: response,
          RegMessage: "Something went wrong. Please try again!",
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc check existing user based on email or mobile for quick appointment
 */

export function checkEmailOrMobileForQuickApp(name, value, artistOwnerId) {
  return function(dispatch) {
    let url = "";

    if (name === "email") {
      url =
        UrlConstants.shopsUrl +
        "/checkAppointmentEmailandMobile?email=" +
        value +
        "&ownerId=" +
        artistOwnerId;
    } else if (name === "mobile") {
      url =
        UrlConstants.shopsUrl +
        "/checkAppointmentEmailandMobile?mobileNumber=" +
        value +
        "&ownerId=" +
        artistOwnerId;
    }

    return APIUtil.getMethod(url, false).then((response) => {
      if (response) {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: response,
        });
      } else {
        dispatch({
          type: types.GET_BY_ID_CONTACT,
          contact: {},
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc get artist available dates
 */
export function getArtistAvailableDatesAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.shopsUrl + "/getAvailableDatesByArtistId",
      data,
      false
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_ARTIST_AVAILABLE_DATES,
          artistAvailableDates: response.data.dates,
        });
      } else {
        dispatch({
          type: types.GET_ARTIST_AVAILABLE_DATES,
          artistAvailableDates: response,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc Create new trasaction API call
 */
export function createTransactionAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.shopsUrl + "/book-appointment",
      data,
      false
    ).then((response) => {
      //console.log("createTransactionAction response", response);

      if (response.status === code.OK) {
        dispatch({
          type: types.CREATE_TRANSACTION,
          isTrascationCreated: true,
          createTransactionData: response.data,
        });
      } else {
        dispatch({
          type: types.CREATE_TRANSACTION,
          isTrascationCreated: false,
          createTransactionData: [],
        });
      }

      return response.data;
    });
  };
}

/**
 * @desc Transactions - status update
 */
export function changeTransactionStatusAction(transactionId, data) {
  let url = UrlConstants.bookTransactionStatusUrl;
  url = url.replace("{transactionId}", transactionId);

  return function(dispatch) {
    return APIUtil.putMethod(url, data, false).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.TRANSACTION_STATUS,
          transactionStatus: response.data,
        });
      } else {
        dispatch({
          type: types.TRANSACTION_STATUS,
          transactionStatus: [],
        });
      }
    });
  };
}

/**
 *
 * @desc Transacations - Create Task
 */
export function createTaskAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.shopsUrl + "/transactionevent",
      data,
      false
    ).then((response) => {
      if (response._id !== "") {
        dispatch({
          type: types.CREATE_TASK,
        });
      } else {
        dispatch({
          type: types.CREATE_TASK,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc set folder permission api call
 */
export function setFolderPermissionAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.shopsUrl + "/setFolderPermission",
      data,
      false
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.SET_PERMISSION,
          isPermissionSet: true,
        });
      } else {
        dispatch({
          type: types.SET_PERMISSION,
          isPermissionSet: false,
        });
      }

      return response;
    });
  };
}

/**
 *
 * @desc get artist available slots
 */
export function getArtistAvailableSlotsAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.shopsUrl + "/artist/slotDetails",
      data,
      false
    ).then((response) => {
      return response;
    });
  };
}
